import { HttpRequestService } from '../../http-request.service';
import { apiURLs } from '../../../globalcontants';
import * as appApiResources from '../../../globalcontants';
import { SiteEntity } from '../../../models/Account/SiteEntity';
import { HttpParams } from '@angular/common/http';
import { UserToken, LoginModel } from '../../../models/Account/UserTokenEntity';
import { map } from 'rxjs/operators';
import { of as observableOf, Observable } from 'rxjs';
import { MAT_INPUT_VALUE_ACCESSOR } from '@angular/material/input';
import { IAccountService } from './IAccountService';
import { LoginUserInstances, MobileUser, RguestSsoMobilePayload, SSOLoginData, UserDetailLandingEntity, UserInstances } from '../../../models/Account/UserInstancesEntity';
import { Injectable } from '@angular/core';
import { UserInfoEntity, UserInformationEntity } from '../../../models/Account/UserInfoEntity ';
import { LoginEntity } from 'src/app/shared/models/Account/LoginEntity';
import { LocationPayloadEntity } from 'src/app/shared/models/Location/LocationEntity';
import { applyEatecTokenPayloadToStorage } from 'src/app/core/services/eatec-token-session.helper';

@Injectable({
  providedIn: 'root',
})
export class AccountService implements IAccountService {
  public apiURLs: any;

  constructor(private httpService: HttpRequestService) {
    // this.apiURLs=this._DynamicApiService.apiURLs;
  }

  GetToken(userName: string, password: string): Observable<UserToken> {
    const data = 'username=' + userName + '&password=' + password + '&grant_type=password';
     return this.httpService.postHttpRequestwithAuth(apiURLs.GetToken, data).pipe(map(user => {
      if (user && user.access_token) {
        applyEatecTokenPayloadToStorage(user);
      }
      return <UserToken>user;
    }));
  }
  UserLogin(username: any, password: any): Observable<LoginUserInstances> {
    const LoginModelApp = {} as LoginEntity;
    LoginModelApp.Password = password ;
    LoginModelApp.UserName = username;
    return this.httpService.postHttpRequest(apiURLs.UserManagementApi.GetVerifiedUser, LoginModelApp);
  }

  ValidateMobileLicense(UserDetail: any): Observable<UserDetailLandingEntity> {
    return this.httpService.postHttpRequest(apiURLs.UserManagementApi.ValidateMobileLicense, UserDetail);
  }
  /**
   * @version 13.2 UI
   * @method UserSsoLogin
   * @Input SSOPayload
   */
   UserSsoLogin(SsoPayload: RguestSsoMobilePayload): Observable<SSOLoginData> {
    return this.httpService.postHttpRequest(apiURLs.UserManagementApi.GetSSo, SsoPayload);
  }
  UserSsoLoginWeb(SsoPayload: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.UserManagementApi.GetSSoWeb, SsoPayload);
  }
  /**
   * UI 13.2
   * @param accessPayload 
   * @returns 
   */
  UserAccess(accessPayload: LocationPayloadEntity): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.UserManagementApi.GetUserAccess, accessPayload);
  }
    /**
   * UI 13.2
   * @param accessPayload 
   * @returns 
   */
  GetAuthClientId(accessPayload: LocationPayloadEntity): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.UserManagementApi.GetclientId, accessPayload);
  }

  GetSystemConfiguration(): any {
    const systemConfigPayload = ['AzureAD','Webclient']
    return this.httpService.postHttpRequest(apiURLs.UserManagementApi.GetSystemConfig, systemConfigPayload).pipe(map(res => {
      return res;
    }));
  }

  /**
   * UI 13.2 Partial modify
   * @param Client_Id 
   * @returns 
   */
  GetTokenByClientId(Client_Id: string,cid:string,cInfo:string): Observable<UserToken> {
    const tenant = localStorage.getItem('tenant');
    const sessionId = localStorage.getItem(appApiResources.EatecSessionId) || null;
    const GetTokenByClientIdObj =  {
        "grantType": "EatecCredential",
        "CID": cid || null,
        "CSInfo": cInfo || null,
        "tenantName": tenant,
        "clientToken": Client_Id.toString(),
        "SessionId": sessionId || null
    }

    // const GetTokenByClientIdObj =  'grantType=EatecCredential&CID='+cid+'&CSInfo='+cInfo+'&tenantName='
    // + tenant + '&clientToken=' +  encodeURIComponent(Client_Id.toString());
    return this.httpService.postHttpRequest(apiURLs.UserManagementApi.GetToken, GetTokenByClientIdObj).pipe(map(user => {
      if (user && (user as any).access_token) {
        applyEatecTokenPayloadToStorage(user);
      }
      return <UserToken>user;
    }));
  }
  GetSitesFromToken(): Observable<SiteEntity[]> {
    const inputParams = new HttpParams();
    // inputParams.append("InstanceName", instanceName);
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.AccountAPI.GetSites);
  }
  GetInstances(): Observable<UserInstances[]> {

    return this.httpService.GetHttpRequest(apiURLs.AccountAPI.GetInstance);
  }
  GetSites(instanceName: string): Observable<SiteEntity[]> {
    const inputParams = new HttpParams().set('InstanceName', instanceName);
    // inputParams.append("InstanceName", instanceName);
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.AccountAPI.GetSites);
  }
  GetLocationsBySiteId(siteId: number): Observable<number[]> {
    const inputParams = new HttpParams().set('siteId', siteId.toString());
    // inputParams.append("siteId", siteId.toString());
    return this.httpService.GetHttpRequestId(inputParams, apiURLs.AccountAPI.GetLocationBySiteId);
  }

  GetUserInformation(): Observable<UserInfoEntity> {
    return this.httpService.GetHttpRequest(apiURLs.UserManagementApi.GetUser);
  }
  /**
   * UI 13.2
   * @returns 
   */
  GetUserInfo(UserId: number): Observable<any> {
    const requestUrl = `${apiURLs.UserManagementApi.GetUser}/` + UserId;
    return this.httpService.GetHttpRequest(requestUrl);
  }

  GeneratePin(mobileData:MobileUser): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.UserManagementApi.GeneratePin, mobileData);
  }

  GetPin(userId:number): Observable<any> {
    return this.httpService.GetHttpRequest(apiURLs.UserManagementApi.GetPin + '?userId=' + userId);
  }

  ChangePassword(requestObj: any): Observable<any> {
    try {
      return this.httpService.postHttpRequest(apiURLs.UserManagementApi.ChangePassword, requestObj);
    } catch (error) {
      console.error(error);
    }
  }

  ForgotPassword(username: string): Observable<any> {
    try {
      const usernameObject = "\"" + username + "\"";
      return this.httpService.putHttpRequest(apiURLs.UserManagementApi.ForgotPassword, usernameObject);
    } catch (error) {
      console.error(error);
    }
  }

}
